// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product:hover .product__thumbnail[data-v-5ba5714a]:before{display:none}", ""]);
// Exports
module.exports = exports;
